import camelCase from 'camelcase'

export function toCamelcaseKeys(obj: any, options?: { deep?: boolean }): any {
  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelcaseKeys(item, options))
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce(
      (acc, key) => {
        const camelKey = camelCase(key)
        const value = obj[key]

        acc[camelKey] = options?.deep ? toCamelcaseKeys(value, options) : value

        return acc
      },
      {} as Record<string, any>
    )
  }

  return obj
}

export const toTitleCase = (text: string) => {
  if (typeof text !== 'string') {
    return text
  }

  return text.charAt(0).toUpperCase() + text.slice(1).replace(/_/g, ' ')
}
